import { Paper, List } from "@mui/material";
import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";
import { useIsDarkMode } from "store/atoms";
import { ListItemToggle } from "components/Settings/ListItemToggle";
import { CollapsibleConfigStyles } from "pages/DashboardPages/ProcessTilesControls/CollapsibleConfigStyles";
import styled, { css } from "styled-components/macro";
import { useTrendChartStore } from "./trendChartStore";
import { LabelWithSubtitle } from "components/Settings/SettingsPage";

const TrendChartConfig = ({ isSettingsPage = false }) => {
  const {
    shouldAlwaysStartTrendChartBarsOnHour,
    setShouldAlwaysStartTrendChartBarsOnHour,
  } = useTrendChartStore();

  const { translate } = useFlightTranslation();
  const [isDarkMode] = useIsDarkMode();
  return (
    <CollapsibleConfigStyles
      onClick={e => e.stopPropagation()}
      $isSettingsPage={isSettingsPage}
      $isDarkMode={isDarkMode}
      $customCss={css`
        position: absolute;
        right: 5px;
      `}
    >
      <StyledPaper elevation={isSettingsPage ? 0 : 2}>
        <List>
          {/* shouldAlwaysStartTrendChartBarsOnHour control */}
          <ListItemToggle
            onChange={() =>
              setShouldAlwaysStartTrendChartBarsOnHour(
                !shouldAlwaysStartTrendChartBarsOnHour
              )
            }
            className={`switchWrapper${
              shouldAlwaysStartTrendChartBarsOnHour ? " checked" : ""
            }`}
            checked={shouldAlwaysStartTrendChartBarsOnHour}
            label={
              <LabelWithSubtitle
                label={translate(`Start_on_hour`)}
                subtitle={translate("Start_on_hour_explanation")}
              />
            }
            style={{ padding: "0px 8px" }}
            labelStyle={{ padding: "0px 8px" }}
          />
        </List>
      </StyledPaper>
    </CollapsibleConfigStyles>
  );
};

export default TrendChartConfig;

const StyledPaper = styled(Paper)`
  margin-right: 12px;
`;
